module.exports = {
          srcSet: __webpack_public_path__ + "e1ce7c9d.jpg"+" 700w"+","+__webpack_public_path__ + "2e2801b2.jpg"+" 1400w"+","+__webpack_public_path__ + "2aaf1f53.jpg"+" 2100w"+","+__webpack_public_path__ + "acaefd14.jpg"+" 2573w",
          images:[ {path: __webpack_public_path__ + "e1ce7c9d.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "2e2801b2.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "2aaf1f53.jpg",width: 2100,height: 1401},{path: __webpack_public_path__ + "acaefd14.jpg",width: 2573,height: 1716}],
          src: __webpack_public_path__ + "e1ce7c9d.jpg",
          toString:function(){return __webpack_public_path__ + "e1ce7c9d.jpg"},
          
          width: 700,
          height: 467
        }